(() => {
  const root = document.querySelector('.fvpd-3861-store-copy');
  if (!root || root.dataset.ready === 'bundle-4999-8499-11999-v1') return;
  root.dataset.ready = 'bundle-4999-8499-11999-v1';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100);
  const slides = [...root.querySelectorAll('[data-gallery-slide]')];
  const galleryButtons = [...root.querySelectorAll('[data-gallery-button]')];
  const variantButtons = [...root.querySelectorAll('[data-variant-choice]')];
  const bundleButtons = [...root.querySelectorAll('[data-bundle-quantity]')];
  const variantInput = root.querySelector('[data-variant-id]');
  const addButton = root.querySelector('[data-add-button]');
  let galleryIndex = 0;
  let selectedVariant = variantButtons.find(button => button.dataset.variantId === variantInput?.value) || variantButtons[0];
  let selectedBundle = bundleButtons.find(button => button.classList.contains('fvpd-is-active')) || bundleButtons[0];

  const hydrateSlide = slide => {
    const image = slide?.querySelector('img[data-fvpd-src]');
    if (!image) return;
    if (image.dataset.fvpdSrcset) image.srcset = image.dataset.fvpdSrcset;
    image.src = image.dataset.fvpdSrc;
    image.removeAttribute('data-fvpd-src');
    image.removeAttribute('data-fvpd-srcset');
  };
  const showSlide = index => {
    galleryIndex = Math.max(0, Math.min(slides.length - 1, index));
    hydrateSlide(slides[galleryIndex]);
    slides.forEach((slide, i) => slide.classList.toggle('fvpd-is-active', i === galleryIndex));
    galleryButtons.forEach((button, i) => {
      button.classList.toggle('fvpd-is-active', i === galleryIndex);
      button.setAttribute('aria-pressed', String(i === galleryIndex));
    });
    const current = root.querySelector('[data-gallery-current]');
    if (current) current.textContent = String(galleryIndex + 1);
  };
  const bundlePrice = (base, button) => base * Number(button.dataset.bundleQuantity || 1) - Number(button.dataset.bundleDiscount || 0);
  const refreshBundleCards = base => {
    bundleButtons.forEach(button => {
      const quantity = Number(button.dataset.bundleQuantity || 1);
      const baskets = Number(button.dataset.baskets || quantity * 2);
      const discount = Number(button.dataset.bundleDiscount || 0);
      const price = bundlePrice(base, button);
      button.dataset.bundlePrice = String(price);
      const priceNode = button.querySelector('span:last-child strong');
      const unitNode = button.querySelector('span:last-child small');
      if (priceNode) priceNode.textContent = money(price);
      if (unitNode) unitNode.textContent = `${money(Math.floor(price / baskets))} each${discount ? ` · Save ${money(discount)}` : ''}`;
    });
  };
  const updateBundle = button => {
    selectedBundle = button;
    const base = Number(selectedVariant?.dataset.variantPrice || root.dataset.basePrice || 0);
    const quantity = Number(button.dataset.bundleQuantity || 1);
    const baskets = Number(button.dataset.baskets || quantity * 2);
    const bouquets = Number(button.dataset.bouquets || baskets * 12);
    const price = bundlePrice(base, button);
    bundleButtons.forEach(item => {
      item.classList.toggle('fvpd-is-active', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    root.querySelectorAll('[data-quantity]').forEach(input => { input.value = String(quantity); input.dispatchEvent(new Event('change', { bubbles: true })); });
    root.querySelectorAll('[data-selected-baskets],[data-sticky-baskets]').forEach(item => { item.textContent = String(baskets); });
    root.querySelectorAll('[data-selected-bouquets]').forEach(item => { item.textContent = String(bouquets); });
    root.querySelectorAll('[data-selected-price],[data-final-price],[data-sticky-price]').forEach(item => { item.textContent = money(price); });
    root.querySelectorAll('[data-final-label]').forEach(item => { item.textContent = `${baskets} Baskets`; });
    if (addButton && !addButton.disabled) addButton.textContent = `Add ${baskets} baskets — ${money(price)}`;
    const stickyCta = root.querySelector('[data-sticky-cta]');
    if (stickyCta) stickyCta.textContent = `Add ${baskets} baskets — ${money(price)}`;
  };
  const updateVariant = (button, syncGallery = true) => {
    selectedVariant = button;
    const available = button.dataset.variantAvailable === 'true';
    const price = Number(button.dataset.variantPrice || 0);
    variantButtons.forEach(item => {
      item.classList.toggle('fvpd-is-active', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    if (variantInput) {
      variantInput.value = button.dataset.variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    root.querySelectorAll('[data-selected-variant-label],[data-selected-variant-summary]').forEach(item => { item.textContent = button.dataset.variantTitle; });
    const heroPrice = root.querySelector('[data-hero-price]');
    if (heroPrice) heroPrice.textContent = money(price);
    if (addButton) {
      addButton.disabled = !available;
      if (!available) addButton.textContent = 'Sold out';
    }
    refreshBundleCards(price);
    updateBundle(selectedBundle || bundleButtons[0]);
    if (syncGallery && button.dataset.variantMediaId) {
      const index = slides.findIndex(slide => slide.dataset.galleryMediaId === button.dataset.variantMediaId);
      if (index >= 0) showSlide(index);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', button.dataset.variantId);
    window.history.replaceState({}, '', url);
  };

  galleryButtons.forEach((button, index) => button.addEventListener('click', () => {
    showSlide(index);
    const linkedVariant = variantButtons.find(item => item.dataset.variantMediaId && item.dataset.variantMediaId === button.dataset.galleryMediaId);
    if (linkedVariant) updateVariant(linkedVariant, false);
  }));
  bundleButtons.forEach(button => button.addEventListener('click', () => updateBundle(button)));
  variantButtons.forEach(button => button.addEventListener('click', () => updateVariant(button, true)));
  let pointerStart = null;
  const stage = root.querySelector('[data-gallery-stage]');
  if (stage) {
    stage.addEventListener('pointerdown', event => { pointerStart = event.clientX; });
    stage.addEventListener('pointerup', event => {
      if (pointerStart == null) return;
      const delta = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(delta) > 45) showSlide(galleryIndex + (delta < 0 ? 1 : -1));
    });
  }
  const stickyAdd = root.querySelector('[data-sticky-add]');
  if (stickyAdd && addButton) stickyAdd.addEventListener('click', () => addButton.click());
  const sticky = root.querySelector('[data-sticky-buy]');
  const quickFacts = root.querySelector('.fvpd-facts');
  let stickyFrame = null;
  const updateSticky = () => {
    stickyFrame = null;
    if (!sticky || !addButton || !quickFacts || window.innerWidth > 699) {
      sticky?.classList.remove('fvpd-sticky--visible');
      return;
    }
    const addBox = addButton.getBoundingClientRect();
    const factsBox = quickFacts.getBoundingClientRect();
    const addVisible = addBox.bottom > 0 && addBox.top < window.innerHeight;
    sticky.classList.toggle('fvpd-sticky--visible', factsBox.bottom < 0 && !addVisible);
  };
  const scheduleSticky = () => { if (stickyFrame == null) stickyFrame = requestAnimationFrame(updateSticky); };
  window.addEventListener('scroll', scheduleSticky, { passive: true });
  window.addEventListener('resize', scheduleSticky);
  const requestedVariant = new URL(window.location.href).searchParams.get('variant');
  const initialVariant = variantButtons.find(button => button.dataset.variantId === requestedVariant) || selectedVariant;
  if (initialVariant) updateVariant(initialVariant, false);
  else if (selectedBundle) updateBundle(selectedBundle);
  updateSticky();
})();
